import { useContext, useEffect } from 'react';
import { useSocket } from '../context/socket';
import { ProfileContext } from '../context/profile';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { FaTasks } from 'react-icons/fa';

const TaskNotificationListener = () => {
  const { getProfile, saveUnread } = useContext(ProfileContext);
  const profile = getProfile();
  const socket = useSocket();
  const navigate = useNavigate();

  useEffect(() => {
    if (!profile || !profile._id || !socket) return;

    socket.emit('USER_CONNECTED', profile._id);
    console.log('User connected with socket:', profile._id);

    socket.on('NEW_TASK_NOTIFICATION', (data) => {

      toast(
        <div onClick={() => navigate(`/task/view/${data.id}`)}>
          <strong>{data.title}</strong>: {data.description}
        </div>,
        {
          duration: 5000,
          position: 'bottom-right',
          style: {
            cursor: 'pointer',
            background: 'lightgreen',
            color: '#000',
            padding: '15px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          },
          icon: <FaTasks />,
        }
      );

      if (data?.unreadCount) {
        saveUnread(data.unreadCount);
      }
    });

    socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    return () => {
      socket.off('NEW_TASK_NOTIFICATION');
      socket.off('disconnect');
    };
  }, [profile?._id, socket, navigate, saveUnread]);

  return null;
};

export default TaskNotificationListener;
